export function toPx(n: number) {
    return `${n}px`
}
